/* eslint-disable security/detect-object-injection */
/* eslint-disable react/jsx-indent */
/* eslint-disable max-len */
/* eslint-disable react/jsx-key */
import React, { useContext, useState, useEffect } from "react";
import { dataService } from "../../../services/data.services";
import { useNavigate, useParams } from "react-router-dom";
import GlobalContext from "../../../components/Context/GlobalContext";
import LoadingOverlay from "react-loading-overlay-ts";
import StoreTable from "./StoreTables";
import Button from "../../../components/Button";
import EmployeeTable from "./EmployeeTables";
import { checkPrivilege } from "../../../CommonMethods/checkPrivilege";
import { Auth } from "aws-amplify";
import Modal from "react-responsive-modal";
import Confirmationpopup from "./Confirmationpopup";
import CardHeader from "../../../components/CardHeader";
import CardHeaders from "../../../components/CardHeaders";
import EmailTemplate from "./EmailTemplate";
import Modalcustom from "../../../components/CustomModal";
import PaymentCommissionView from "./PaymentCommissionView";

export default function ViewMerchantDetails() {
    const { setToastErrorMessage, setToastmessage } = useContext(GlobalContext);
    const navigate = useNavigate();
    const { id, email } = useParams();
    const [isUpdated, setIsUpdated] = useState(false);
    const [viewData, setviewData] = useState({});
    const [hasLoginMerchant, setLoginAsMerchant] = useState(false)
    const [loginMerchantLoading, setLoginMerchantLoading] = useState(false)
    const [modalpopup, setmodalpopup] = useState({})
    const [merchantLoginModal, setMerchantLoginModal] = useState(false)
    const [activateLoading, setactivateLoading] = useState(false)
    const [note, setNote] = useState('');
    const [noteError, setNoteError] = useState('');
    const [noteFocus, setNoteFocus] = useState(false);
    const getData = async () => {
        const email_address = encodeURIComponent(email)
        try {
            let res = await dataService.GetAPI(`merchant-users/${email_address}`);
            setviewData(res.data);
        } catch (error) {
            setToastErrorMessage(error.message);
        }
    };
    const hasUpdatePrivilege = checkPrivilege('update_merchant');
    const hasActivatePrivilege = checkPrivilege('activate_or_deactivate_merchant')
    const hasStorePrivilege = checkPrivilege('store_list')
    const hasEmployeeList = checkPrivilege('employee_list')
    const getDetails = async () => {
        const response = await Auth.currentSession();
        if (response?.idToken?.payload['custom:merchant_privileges'] && response?.idToken?.payload['custom:merchant_privileges'] !== '') {
            setLoginAsMerchant(true);
        }
    }

    const getLocalStorage = () => {
        const localStorageItems = Object.keys(localStorage);
        let localStorageObject = {}
        localStorageItems.forEach(element => {
            localStorageObject[element] = localStorage.getItem(element)
        });
        return localStorageObject;
    }
    const handleLoginAsMerchant = async () => {
        if (note.trim().length > 500) {
            setNoteError('Description too long. Max 500 characters.');
            return;
        } else if(note.trim().length == 0){
            setNoteError('This field is mandatory');
            return;
        }
        setLoginMerchantLoading(true)
        setactivateLoading(true)
        let body = {};
        body['merchant_email_address'] = email;
        body['admin_session'] = getLocalStorage();
        body['reason']=note;
        try {
            const res = await dataService.PostAPI(body, `admin-users/login-as-merchant`);
            if (res?.data?.data?.login_url !== '') {
                window.open(
                    res?.data?.data?.login_url,
                    '_blank'
                );
            }
            setLoginMerchantLoading(false)
            handleClose()
        } catch (error) {
            console.error(error)
            setToastErrorMessage(error.message);
            setLoginMerchantLoading(false)
        }

        
    }
    // const checkPrivilege = (privilegeToBeChecked) => {
    //     if (privileges.hasOwnProperty(privilegeToBeChecked)) {
    //         return true;
    //     } else {
    //         false
    //     }
    // }
    /**
     * Fetches all stores for a merchant (handling pagination)
     */
    const fetchAllStoresForMerchant = async (merchantEmail) => {
        const allStores = [];
        let pageNumber = 1;
        let hasMorePages = true;

        while (hasMorePages) {
            try {
                const encodedEmail = encodeURIComponent(merchantEmail);
                const res = await dataService.GetAPI(`stores/list?page_number=${pageNumber}&merchant=${encodedEmail}`);
                
                if (!res.error && res.data?.data) {
                    allStores.push(...res.data.data);
                    const totalPages = Math.ceil(res.data.total_count / 10);
                    hasMorePages = pageNumber < totalPages;
                    pageNumber++;
                } else {
                    hasMorePages = false;
                }
            } catch (error) {
                console.error('Error fetching stores:', error);
                hasMorePages = false;
            }
        }

        return allStores;
    }

    /**
     * Deactivates all active stores for a merchant
     * Returns an object with success count and total count
     */
    const deactivateAllStoresForMerchant = async (merchantEmail) => {
        try {
            const stores = await fetchAllStoresForMerchant(merchantEmail);
            const activeStores = stores.filter(store => store.status === true);
            
            if (activeStores.length === 0) {
                return { successCount: 0, totalCount: 0 };
            }

            // Process stores in batches to avoid overwhelming the network
            const batchSize = 10;
            let successCount = 0;
            let failedCount = 0;

            for (let i = 0; i < activeStores.length; i += batchSize) {
                const batch = activeStores.slice(i, i + batchSize);
                
                // Deactivate stores in current batch
                const batchPromises = batch.map(async (store) => {
                    try {
                        const storeEmail = encodeURIComponent(store.email_address);
                        const res = await dataService.PatchAPI(
                            { status: 'false' },
                            `stores/activate-deactivate?email=${storeEmail}`
                        );
                        if (!res.error) {
                            return { success: true, store: store.email_address };
                        } else {
                            console.error(`Error deactivating store ${store.email_address}:`, res.data?.message);
                            return { success: false, store: store.email_address };
                        }
                    } catch (error) {
                        console.error(`Error deactivating store ${store.email_address}:`, error);
                        return { success: false, store: store.email_address };
                    }
                });

                // Use Promise.allSettled to handle partial failures gracefully
                const results = await Promise.allSettled(batchPromises);
                
                results.forEach((result) => {
                    if (result.status === 'fulfilled' && result.value.success) {
                        successCount++;
                    } else {
                        failedCount++;
                    }
                });

                // Add a small delay between batches to avoid overwhelming the server
                if (i + batchSize < activeStores.length) {
                    await new Promise(resolve => setTimeout(resolve, 100));
                }
            }

            return { successCount, totalCount: activeStores.length, failedCount };
        } catch (error) {
            console.error('Error deactivating stores:', error);
            return { successCount: 0, totalCount: 0, failedCount: 0, error: true };
        }
    }

    const handleActivate = async () => {
        setactivateLoading(true)
        const body = {
            status: modalpopup.status === true ? 'false' : 'true'
        }
        try {
            const encodedEmail = encodeURIComponent(modalpopup['email_address']);
            const res = await dataService.PatchAPI(body, `merchant-users/activate-deactivate?${encodedEmail}`);
            if (!res.error) {
                // If deactivating merchant, also deactivate all associated stores
                if (modalpopup.status === true) {
                    try {
                        const storeDeactivationResult = await deactivateAllStoresForMerchant(modalpopup['email_address']);
                        if (storeDeactivationResult.error) {
                            // If there was an error fetching stores, still show success for merchant
                            setToastmessage(`Merchant user deactivated successfully. Unable to deactivate stores.`)
                        } else if (storeDeactivationResult.successCount > 0) {
                            if (storeDeactivationResult.failedCount > 0) {
                                setToastmessage(`Merchant user deactivated successfully. ${storeDeactivationResult.successCount} of ${storeDeactivationResult.totalCount} store(s) deactivated.`)
                            } else {
                                setToastmessage(`Merchant user deactivated successfully. ${storeDeactivationResult.successCount} store(s) have been deactivated.`)
                            }
                        } else {
                            setToastmessage(`Merchant user deactivated successfully`)
                        }
                    } catch (storeError) {
                        // If store deactivation fails, still show success for merchant deactivation
                        console.error('Error during store deactivation:', storeError);
                        setToastmessage(`Merchant user deactivated successfully. Some stores may not have been deactivated.`)
                    }
                } else {
                    setToastmessage(`Merchant user activated successfully`)
                }
                setactivateLoading(false);
                setmodalpopup({});
                getData();
                setIsUpdated(!isUpdated); // Trigger store table refresh

            } else {
                setToastErrorMessage(res.data.message);
                setactivateLoading(false);

            }

        } catch (error) {
            setToastErrorMessage(error.response?.data?.message || error.message || 'An error occurred');
            setactivateLoading(false);
            setmodalpopup({})

        }



    }
    const handleClose = () => {
        setmodalpopup({});
        setMerchantLoginModal(false)
        setactivateLoading(false)
    }
    useEffect(() => {
        getDetails();
    }, [])
    useEffect(() => {
        getData();
    }, [id]);


    return (
        <CardHeaders paths={['Merchants']} pathurls={['/manage-merchants']} activePath="Merchant Details" header="View Merchant" back={`/manage-merchants`}>
            <LoadingOverlay
                active={Object.keys(viewData).length === 0}
                spinner
                text="Loading Merchant details..."
            >
                {Object.keys(viewData).length > 0 && (
                    <div className="bg-[#f5f5f5] pl-[15px] pt-[15px] pb-[15px] pr-1 h-merchantheight">
                        <div className="bg-white px-4 pr-1 h-full overflow-auto scrollBar">
                            <div className=" pt-8 mb-6">
                                <p className="  text-xl font-medium text-[#4B4B4B]">
                                    Merchant Information
                                </p>
                            </div>
                            <div className="border border-[#EB9DC7] pl-[22px] pb-5 pr-4">
                                <div className=" pt-[10px] flex flex-col xl:flex-row xl:justify-between xl:items-start gap-6">
                                    <div className="flex space-x-[60px] flex-1 min-w-0">
                                        <div className="flex flex-col space-y-[30px]">
                                            <div className="h-[48px]">
                                                <h1 className="view-head">Merchant Name</h1>
                                                <p className="view-sub max-w-[300px] truncate" title={viewData?.name}>{viewData?.name}</p>
                                            </div>
                                            <div className="h-[48px]">
                                                <h1 className="view-head">Address</h1>
                                                <p className="view-sub max-w-[300px] truncate" title={viewData?.address}>{viewData?.address}</p>
                                            </div>
                                            <div className="h-[48px]">
                                                <h1 className="view-head">Postal Code</h1>
                                                <p className="view-sub max-w-[300px] truncate" title={viewData?.postal_code}>{viewData?.postal_code}</p>
                                            </div>



                                        </div>

                                        <div className="flex flex-col space-y-[30px] ">
                                            <div className="h-[48px]">
                                                <h1 className="view-head">Business Name</h1>
                                                <p className="view-sub max-w-[300px] truncate" title={viewData?.business_name}>{viewData?.business_name}</p>
                                            </div>
                                            <div className="h-[48px]">
                                                <h1 className="view-head">City</h1>
                                                <p className="view-sub max-w-[300px] truncate" title={viewData?.city}>{viewData?.city}</p>
                                            </div>
                                            <div className="h-[48px]">
                                                <h1 className="view-head">Phone Number</h1>
                                                <p className="view-sub max-w-[300px] truncate" title={viewData?.phone_number}>{viewData?.phone_number}</p>
                                            </div>
                                        </div>
                                        <div className="flex flex-col justify-end">
                                            <h1 className="view-head">Email Address</h1>
                                            <p className="view-sub max-w-[300px] truncate" title={viewData?.email_address}>{viewData?.email_address}</p>
                                        </div>
                                    </div>
                                    <div className="flex flex-wrap gap-2 xl:gap-3 flex-shrink-0">
                                        {hasLoginMerchant && <Button
                                            classKey={`p-[10px] text-xs xl:text-sm border border-primary rounded-[12px] text-primary font-normal whitespace-nowrap`}
                                            text="Login as Merchant"
                                            disabled={loginMerchantLoading}
                                            type="button"
                                            handleClick={() => {
                                                setNote('')
                                                setNoteError('')
                                                setMerchantLoginModal(true)}}
                                            testId="merchant-login"
                                            color="#9E2064"
                                        />}
                                        {hasActivatePrivilege && <button
                                            className="p-[10px] text-xs xl:text-sm border border-primary rounded-[12px] text-primary font-normal whitespace-nowrap"
                                            data-testid="status-btn"
                                            type="submit"
                                            onClick={() => {
                                                setmodalpopup({
                                                    'name': viewData?.name,
                                                    'status': viewData?.status,
                                                    'email_address': viewData?.email_address
                                                })
                                            }}
                                        >
                                            {viewData?.status ? 'Deactivate' : 'Activate'}
                                        </button>}
                                        {hasUpdatePrivilege && <button
                                            onClick={() =>
                                                navigate(`/manage-merchants/${viewData.email_address}/edit`)
                                            }
                                            className="p-[10px] text-xs xl:text-sm border border-primary rounded-[12px] text-primary font-normal whitespace-nowrap"
                                            type="submit"
                                        >
                                            Edit
                                        </button>}
                                    </div>
                                </div>
                            </div>

                            {hasStorePrivilege && <StoreTable type="stores" viewData={viewData} header="Store" isUpdated={isUpdated} setIsUpdated={setIsUpdated} handleFetch={getData} />}
                            {hasEmployeeList && <EmployeeTable viewData={viewData} isUpdated={isUpdated} setIsUpdated={setIsUpdated} />}

                            {/* Payment Commission Section */}
                            <div className="mt-8" />
                            {(() => {
                                const COMMISSION_SECTIONS = [
                                    // Crypto
                                    { key: 'crypto_payment_commision',          title: 'Crypto',             methodKey: 'crypto' },
                                    // Debit & Credit Cards
                                    { key: 'amex_payment_commision',            title: 'American Express',   methodKey: 'American Express' },
                                    { key: 'discover_payment_commision',        title: 'Discover',           methodKey: 'Discover' },
                                    { key: 'diner_club_payment_commision',      title: 'Diners Club',        methodKey: 'Diners Club' },
                                    { key: 'jcb_payment_commision',             title: 'JCB',                methodKey: 'JCB' },
                                    { key: 'mastercard_payment_commision',      title: 'MasterCard',         methodKey: 'MasterCard' },
                                    { key: 'creditcard_payment_commision',      title: 'Visa',               methodKey: 'Visa' },
                                    { key: 'cb_payment_commision',              title: 'CB',                 methodKey: 'CB' },
                                    // Global Wallets
                                    { key: 'samsung_pay_payment_commision',     title: 'Samsung Pay',        methodKey: 'Samsung Pay' },
                                    { key: 'revolut_pay_payment_commision',     title: 'Revolut Pay',        methodKey: 'Revolut Pay' },
                                    { key: 'google_pay_payment_commision',      title: 'Google Pay',         methodKey: 'Google Pay' },
                                    { key: 'apple_pay_payment_commision',       title: 'Apple Pay',          methodKey: 'Apple Pay' },
                                    { key: 'paypal_payment_commision',          title: 'PayPal',             methodKey: 'PayPal' },
                                    // Regional Wallets
                                    { key: 'wechat_payment_commision',          title: 'WeChat Pay',         methodKey: 'WeChat Pay' },
                                    { key: 'alipay_payment_commision',          title: 'Alipay+',            methodKey: 'Alipay+' },
                                    { key: 'unionpay_payment_commision',        title: 'Union Pay',          methodKey: 'UnionPay WAP' },
                                    // Buy Now Pay Later
                                    { key: 'klarna_payment_commision',          title: 'Klarna',             methodKey: 'Klarna' },
                                ];
                                const hasAnyCommission = COMMISSION_SECTIONS.some(s => viewData[s.key]);
                                if (!hasAnyCommission) return null;
                                return (
                                    <>
                                        <div className="pt-8 pb-4">
                                            <p className="text-xl font-medium text-[#4B4B4B]">Payment Commission</p>
                                        </div>
                                        {COMMISSION_SECTIONS.map(section => (
                                            <PaymentCommissionView
                                                key={section.key}
                                                title={section.title}
                                                methodKey={section.methodKey}
                                                commissionData={viewData[section.key]}
                                            />
                                        ))}
                                    </>
                                );
                            })()}
                        </div>
                    </div>
                )}
                <Modal open={Object.keys(modalpopup).length > 0} onClose={handleClose}>
                    <Confirmationpopup
                        message={`Are you sure you want to ${modalpopup.status === true ? 'deactivate' : 'Activate'} the merchant ${modalpopup.name}? `}
                        Title={`${modalpopup.status === true ? 'Deactivate' : 'Activate'} Merchant`}
                        handleSubmit={handleActivate}
                        stateKey={`${modalpopup.status === true ? 'Deactivate' : 'Activate'}`}
                        loading={activateLoading}
                        handleClose={handleClose}
                    />

                </Modal>
                <Modalcustom open={merchantLoginModal} container={'h-[365px] mx-auto mt-[100px]'} onClose={handleClose}>
                    <EmailTemplate 
                        handleSubmit={handleLoginAsMerchant}
                        noteFocus={noteFocus}
                        setNoteFocus={setNoteFocus}
                        note={note}
                        setNote={setNote}
                        noteError={noteError}
                        setNoteError={setNoteError}
                        loading={activateLoading}
                        handleClose={handleClose} />
                </Modalcustom>
            </LoadingOverlay>
        </CardHeaders>
    );
}